export default "__VITE_ASSET__CDHTeldt__"